module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClasses
  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prependbtn) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixIGCls + '-btn']
  }, [_vm._t("prependbtn")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.prepend) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixIGCls + '-addon']
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('span', {
    class: _vm.iconClasses,
    on: {
      "click": _vm.$_onIconClick
    }
  }, [_c('i', {
    staticClass: "aid",
    class: 'aid-' + [_vm.icon]
  })]) : _vm._e(), _vm._v(" "), (_vm.isGroup) ? _c('div', {
    class: _vm.prefixCls
  }, [_c('input', {
    ref: "input",
    class: _vm.inputClasses,
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "number": _vm.number,
      "autofocus": _vm.autofocus,
      "clearable": _vm.clearable
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$_onEnter($event)
      }, _vm.$_onKeyup],
      "keypress": _vm.$_onKeypress,
      "keydown": _vm.$_onKeydown,
      "focus": _vm.$_onFocus,
      "blur": _vm.$_onBlur,
      "input": _vm.$_onInput,
      "change": _vm.$_onChange
    }
  }), _vm._v(" "), (_vm.isClear) ? _c('span', {
    class: [_vm.prefixInputCls + '-close-icon'],
    on: {
      "click": _vm.$_onClearIconClick
    }
  }, [_c('i', {
    staticClass: "aid aid-close-circle text-muted"
  })]) : _vm._e()]) : _c('input', {
    ref: "input",
    class: _vm.inputClasses,
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "number": _vm.number,
      "autofocus": _vm.autofocus,
      "clearable": _vm.clearable
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$_onEnter($event)
      }, _vm.$_onKeyup],
      "keypress": _vm.$_onKeypress,
      "keydown": _vm.$_onKeydown,
      "focus": _vm.$_onFocus,
      "blur": _vm.$_onBlur,
      "input": _vm.$_onInput,
      "change": _vm.$_onChange
    }
  }), _vm._v(" "), (_vm.isClear && !_vm.isGroup) ? _c('span', {
    class: [_vm.prefixInputCls + '-close-icon'],
    on: {
      "click": _vm.$_onClearIconClick
    }
  }, [_c('i', {
    staticClass: "aid aid-close-circle text-muted"
  })]) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixIGCls + '-addon']
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.appendbtn) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixIGCls + '-btn']
  }, [_vm._t("appendbtn")], 2) : _vm._e()] : _c('textarea', {
    ref: "textarea",
    class: _vm.textareaClasses,
    style: (_vm.textareaStyles),
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "rows": _vm.rows,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$_onEnter($event)
      }, _vm.$_onKeyup],
      "keypress": _vm.$_onKeypress,
      "keydown": _vm.$_onKeydown,
      "focus": _vm.$_onFocus,
      "blur": _vm.$_onBlur,
      "input": _vm.$_onInput
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14e90980"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/input.vue
// module id = 346
// module chunks = 0